import { ChangeDetectionStrategy, Component, inject, signal, } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { InnerHtmlComponent } from '../shared/components/inner-html/inner-html.component';
import { Page } from '../shared/model/page.model';
import { SiteService } from '../shared/services/site.service';


@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-page',
  imports: [InnerHtmlComponent],
  template: `
    <app-inner-html classes="layout page py-24 text-gray-500" [html]="content()"></app-inner-html>
  `
})

/**
 * Page component
 */
export class PageComponent {
  route = inject(ActivatedRoute);
  siteService = inject(SiteService);
  content = signal('');

  constructor() {
    this.route.data
      .pipe(takeUntilDestroyed())
      .subscribe(data => {
        const page: Page = data['page'];
        this.content.set(
          page.centerContent
            .find(cc => cc.center === this.siteService.center()?.id)?.content || page.content
        );
      })

  }
}
